<div
  class="flex w-full items-center justify-between gap-2 rounded-md px-4 py-2 shadow-md"
  [ngClass]="ngPanelClass">
  <mat-icon [fontIcon]="icon" class="shrink-0" />
  <div class="flex h-10 flex-1 flex-col justify-center truncate">
    <span class="truncate text-sm font-medium"
      >Festivo {{ holidayType | holidayType }}</span
    >
    <span class="truncate text-sm leading-none">{{ data.message }}</span>
  </div>
  <button mat-icon-button (click)="snackBarRef.dismiss()">
    <mat-icon>close</mat-icon>
  </button>
</div>
